import React, { useEffect, useState, useRef } from 'react'
import { Section } from 'newComponents'
import './styles.scss'

const Twitter = (props) => {
  const { data } = props
  const { primary } = data
  const { twitter } = primary
  const tweetUrl = twitter?.text

  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [embedded, setEmbedded] = useState(false)
  const embedContainerRef = useRef()

  const handleScriptLoad = () => {
    if (!scriptLoaded) setScriptLoaded(true)
  }

  useEffect(() => {
    if (!scriptLoaded && tweetUrl) {
      const script = document.createElement('script')
      script.src = 'https://platform.twitter.com/widgets.js'
      script.async = true
      script.onload = handleScriptLoad
      document.getElementsByClassName('twitter-embed')[0].appendChild(script)
    }
    if (scriptLoaded && tweetUrl && !embedded) {
      const tweetUrlComponents = tweetUrl.split('/')
      const tweetId = tweetUrlComponents[tweetUrlComponents.length - 1]
      const tweetIdWithoutQueries = tweetId.split('?')[0]
      window.twttr.widgets.createTweet(tweetIdWithoutQueries, embedContainerRef.current)
      setEmbedded(true)
    }
  }, [scriptLoaded, embedded])

  if (!tweetUrl) return null

  return (
    <Section className="twitter-embed">
      <div ref={embedContainerRef} />
    </Section>
  )
}

export default Twitter
